const simpleSelector = state => state

export default simpleSelector